import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Contact, Sparkles, ShieldCheck } from 'lucide-react';
import { Button } from '@getro/rombo';

export const DisabledState = ({ isLoading, onEnable }) => (
  <Flex
    sx={{
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      overflow: 'auto',
    }}
  >
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        width: '480px',
        pt: '100px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '232px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '16px',
            bottom: '16px',
            transform: 'translateX(-50%)',
            width: '400px',
            bg: 'white',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            boxShadow: '0px 1px 4px 0px rgba(27, 36, 50, 0.06), 0px 2px 32px 0px rgba(27, 36, 50, 0.06)',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              height: '20px',
              bg: 'neutral.50',
              display: 'flex',
              alignItems: 'center',
              px: '9px',
              gap: '6px',
            }}
          >
            <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', bg: 'neutral.100' }} />
            <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', bg: 'neutral.100' }} />
            <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', bg: 'neutral.100' }} />
          </Box>
          <Flex
            sx={{
              flexDirection: 'column',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '170px',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '37px',
                left: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
              }}
            >
              <Box sx={{ height: '12px', width: '92px', bg: 'neutral.50', borderRadius: '4px' }} />
              <Box sx={{ height: '6px', width: '170px', bg: 'neutral.50', borderRadius: '13.349px' }} />
              <Box sx={{ height: '6px', width: '124px', bg: 'neutral.50', borderRadius: '13.349px' }} />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: '92px',
                left: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
              }}
            >
              <Box sx={{ height: '6.472px', width: '80.905px', bg: 'neutral.50', borderRadius: '13.349px' }} />
              <Box sx={{ height: '12px', width: '100%', bg: 'neutral.50', borderRadius: '4px' }} />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: '123px',
                left: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
              }}
            >
              <Box sx={{ height: '6.472px', width: '80.905px', bg: 'neutral.50', borderRadius: '13.349px' }} />
              <Box sx={{ height: '12px', width: '100%', bg: 'neutral.50', borderRadius: '4px' }} />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: '154px',
                left: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
              }}
            >
              <Box sx={{ height: '6.472px', width: '80.905px', bg: 'neutral.50', borderRadius: '13.349px' }} />
              <Box sx={{ height: '12px', width: '100%', bg: 'neutral.50', borderRadius: '4px' }} />
            </Box>
          </Flex>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '52px',
            background: 'linear-gradient(180deg, rgba(247, 250, 252, 0) 0%, #F7FAFC 100%)',
          }}
        />
      </Box>
      <Flex sx={{ flexDirection: 'column', gap: '16px', width: '400px' }}>
        <Text
          sx={{
            fontSize: '18px',
            fontWeight: '600',
            lineHeight: '1.4',
            color: 'text.dark',
          }}
        >
          Invite people to join this list
        </Text>

        <Text
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            color: 'text.main',
          }}
        >
          Enable a signup form you can share to let people join this list.
          <br />
          <br />
          New signups will be added automatically, so you can grow this list over time.
        </Text>
        <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
          <Flex sx={{ gap: '8px', alignItems: 'center' }}>
            <Flex
              sx={{
                bg: 'purple.100',
                p: '8px',
                borderRadius: '99px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Contact size={16} color="#6D33FF" />
            </Flex>
            <Text sx={{ fontSize: '14px', lineHeight: '1.4', color: 'text.main', flex: 1 }}>
              Create Talent communities or Talent networks
            </Text>
          </Flex>

          <Flex sx={{ gap: '8px', alignItems: 'center' }}>
            <Flex
              sx={{
                bg: 'purple.100',
                p: '8px',
                borderRadius: '99px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Sparkles size={16} color="#6D33FF" />
            </Flex>
            <Text sx={{ fontSize: '14px', lineHeight: '1.4', color: 'text.main', flex: 1 }}>
              Automate it with AI agents
            </Text>
          </Flex>

          <Flex sx={{ gap: '8px', alignItems: 'center' }}>
            <Flex
              sx={{
                bg: 'purple.100',
                p: '8px',
                borderRadius: '99px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ShieldCheck size={16} color="#6D33FF" />
            </Flex>
            <Text sx={{ fontSize: '14px', lineHeight: '1.4', color: 'text.main', flex: 1 }}>
              Not indexed by search engines
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Button
        variant="primary"
        size="medium"
        sx={{
          width: '400px',
          height: '40px',
          px: '24px',
          py: '8px',
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '20px',
          justifyContent: 'center',
        }}
        onClick={onEnable}
        disabled={isLoading}
      >
        {isLoading ? 'Enabling...' : 'Enable signup form'}
      </Button>
    </Flex>
  </Flex>
);

DisabledState.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onEnable: PropTypes.func.isRequired,
};
